import { QueryClient } from '@tanstack/react-query';

import { ApiError } from '@/api/client';

/**
 * Lives in its own module rather than beside <Providers> so that file only
 * exports components — otherwise Vite's fast refresh gives up on it and every
 * edit does a full page reload.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      // Never retry a request the server has definitively rejected — only
      // transient failures are worth repeating.
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.status >= 400 && error.status < 500) {
          return false;
        }
        return failureCount < 2;
      },
    },
  },
});
